export default __webpack_public_path__ + "static/media/KSURF-new.d80ed2a9.png";